import { Dictionary } from "../../Interfaces";

export function getCorrectAmericanOddsString(displayOdds: Dictionary<string>)
{
    if (displayOdds && displayOdds["american"]) {
        return displayOdds["american"].replace("−", "-");
    }
    else {
        return "0";
    }
};